/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { profileDetail, walletDetail, transactionsDetails } from './test-data/profile.detail';
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../application";
import {GET_MY_ASSETS} from "../pages/MyTransactions/graphql/get-my-transactions.query";
import {GET_MY_PROFILE} from "../pages/MyProfile/graphql/get-my-profile-query";
import {UPDATE_MY_PROFILE} from "../pages/MyProfile/graphql/update-my-profile.mutation";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { getInstance } from 'antd/lib/message';
import {SOUND, VIDEO} from "../assets/images"

const is = require("is_js");

const { LoggerModule } = require("@vlinder-web/logger-module-react");
const SERVICE_NAME = "profile.service";
const log: any = LoggerModule.getInstance();

const storageService = StorageModule.getInstance();


interface IProps {
    imageServer:any,
 }


const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class ProfileService {
    name = SERVICE_NAME;
    private static instance: ProfileService;
    private vapp: VApplication;
    private imageServer;
    
    private constructor(props:IProps| any = {}) {
        this.vapp = VApplication.getInstance();
        this.report();
        this.imageServer = props?.imageServer
     
    }

    static getInstance(props:IProps| any = {}) {
        if (!this.instance) {
            this.instance = new ProfileService(props);
        }
     
        return this.instance;
    }
    async init() {}

    

    async getProfileData() {

        let _profileData = profileDetail;
        // return _profileData;
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_MY_PROFILE,
                    fetchPolicy:'network-only'
                });
                log.success(SERVICE_NAME, "userProfile ", res);
               if(res?.data?.getMyProfile){
                   let _res = res?.data?.getMyProfile;
                   let _profile = {
                       ..._res,
                    name:_res?.fullName,
                    email:_res?.email,
                    description:_res?.bio,
                    profileImg: _res?.image ?? _profileData?.profileImg,
                    bannerImg: _res?.bannerImg ?? _profileData?.bannerImg
                   }
                   return _profile;
               }
               else return false
            }
        } catch (err:any) {
            log.error(SERVICE_NAME, "error in getMyProfile", err);
           //  toast.error(`${err?.message}`);
            throw Error(`${err?.message}`);
        }
    }

    async getWalletData() {
        let _walletData = walletDetail;
        return _walletData;
    }

    async updateProfile(formData:any){
        log.info(`inside update profile`,);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: UPDATE_MY_PROFILE,
                    variables: {
                        ...formData
                    },
                });
                log.success(SERVICE_NAME, "profile updated successfully ", res);
               if(res?.data){
                   return res?.data;
               }
            }
        } catch (err:any) {
            log.error(SERVICE_NAME, "profile update failed", err);
            throw Error(`${err?.message}`)
        }
    }

    // async getTransactionData() {
    //     let _transactionData = transactionsDetails;
    //     return _transactionData;
    // }

    async getTransactionData(size: number, offset: number, signature:any) {
        const profileService = ProfileService.getInstance()
  
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("wallet-api");
    //    const _found = transactionsDetails;
        
        try {
            if (client) {
                const res = await client.query({
                    query: GET_MY_ASSETS,
                    variables: {
                        input:{
                            skip:offset,
                            limit:size
                        },
                        auth:{
                            signature: signature?.result,
                            message: "Please sign to prove your wallet address",
                            expected_address: signature?.params[1]
                        }
                        
                    },
                });
                log.success(SERVICE_NAME, "claim asset result: ", res);

               if(res?.data?.getMyAssets){
                   let _data = res?.data?.getMyAssets?.data;

                   let results = _data?.map((item:any)=>{
                    const imgUrl = item?.img;
                    const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
                    const imgBBformat = imgUrl?.split('/');
                    const ibbFormat = imgBBformat[imgBBformat.length-3]
                 
                    let _img;
                     if(ibbFormat === "i.ibb.co"){
                        // _img =`${profileService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
                        _img=item?.img
                     
                     } 
                     else {
                        //  _img = `${profileService.imageServer}${urlFormat}/:/rs=h:500`
                        _img = item?.img
                     }

                      if(item?.type === "audio"){
                          _img = SOUND
                      }
                      if(item?.type === "video"){
                          _img = VIDEO
                      }
                        
                        return({
                            ...item,
                            idx:item?.serialNo,
                            title: item?.title ,
                            subtitle:item?.subtitle?.replace(/<[^>]*>?/gm, ''),
                            description: item?.subtitle,
                            tag: item?.tag?.toUpperCase(),
                            category: item?.tag?.toLowerCase(),
                            serialNo:`Rare #/${item?.serialNo}`,
                            img:_img,
                            price: item?.price.map(key=>{
                                return({
                                    ...key,
                                    locale:"en-us"
                                })
                            }),
                            purchasedDate: item?.purchasedDate,
                            audioDetail: item?.type === "audio" ? true : false,
                            videoDetail: item?.type === "video" ? true : false,
                            networkType:null,
                        })
                    })

                   return{
                    pagination: {
                        nextOffset: offset + res?.data?.getMyAssets?.pageSize,
                        totalItems: res?.data?.getMyAssets?.totalCount,  
                    },
                    results,
                   }
               }
            }
        } catch (err) {
            log.error(SERVICE_NAME, "error in get assets lock state", err);
            // throw Error(`${err?.message}`)
            return err;
        }
   }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
